import { render, staticRenderFns } from "./BookType_List.vue?vue&type=template&id=3a7cb9ce"
import script from "./BookType_List.vue?vue&type=script&lang=js"
export * from "./BookType_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports